import logging from 'utils/logging';

const log = logging.getLogger('momentCacheManager');

// Registry of cache reset functions, keyed by scope ('all' or 'round')
const cacheResets = {
  all: [],
  round: [],
};

/**
 * Register a cache reset function.
 * @param {'all' | 'round'} type - 'round' caches are cleared each round; 'all' caches are cleared on full game reset
 * @param {Function} fn - Function that clears the cache
 */
export const registerCacheReset = (type, fn) => {
  if (!cacheResets[type]) {
    log.warn(`Unknown cache reset type: ${type}`);
    return;
  }
  cacheResets[type].push(fn);
};

/**
 * Clear all caches (both 'all' and 'round' scoped).
 * Called on full game reset (PREGAME -> LOBBY).
 */
export const resetAllCaches = () => {
  log.info('Resetting ALL caches');
  cacheResets.all.forEach(fn => fn());
  cacheResets.round.forEach(fn => fn());
};

/**
 * Clear round-scoped caches only.
 * Called on round transitions (LOBBY -> ROUND).
 */
export const resetRoundCaches = () => {
  log.info('Resetting round caches');
  cacheResets.round.forEach(fn => fn());
};
